module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"seeCode":"See code","accessRevoked":"Access revoked","action":{"revokeAccess":"Revoke access"}}}')
  delete Component.options._Ctor
}
